const initialState = {
    remove: [],
    approvedata: [],
    inactive:[],
  };
  
  const ADoctorlistReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'fetch_Remove_success':
        return { ...state, remove: action.payload };
        case 'FETCH_Approve_SUCCESS':
        return { ...state, approvedata: action.payload };
        case 'FETCH_Inactive_SUCCESS':
        return { ...state, inactive: action.payload };
      
    

      default:
        return state;
    }
  };
  
  export default ADoctorlistReducers;
  
  